import React from 'react';
import Svg, {Path} from 'react-native-svg';
import {Props as SvgProps} from '../../../shared/assets/SvgProps';

const SearchArrowIcon: React.FC<SvgProps> = ({color = '#707070', borderColor = '#E5E7EB', bgColor= '#F1F2F3'}) => (
  <Svg width="47" height="48" viewBox="0 0 47 48" fill="none">
    <Path
      d="M4 0.5H46.5V47.5H4C2.067 47.5 0.5 45.933 0.5 44V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill={bgColor}
    />
    <Path
      d="M46.5 0.5H4C2.067 0.5 0.5 2.067 0.5 4V44C0.5 45.933 2.067 47.5 4 47.5H46.5"
      stroke={borderColor}
    />
    <Path
      d="M24.3333 19.0026L29 23.6693L24.3333 28.3359"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M18 23.6641L29 23.6641"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default SearchArrowIcon;